import {
  GET_PROFILE_GROUPS_ERROR,
  GET_PROFILE_GROUPS_START,
  GET_PROFILE_GROUPS_SUCCESS,
} from 'constants/action-types/organizations/profiles/getProfileGroups';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_PROFILE_GROUPS_START:
      return {
        ...state,
        profileGroups: {
          ...state.profileGroups,
          loading: true,
          error: null,
        },
      };
    case GET_PROFILE_GROUPS_SUCCESS:
      return {
        ...state,
        profileGroups: {
          ...state.profileGroups,
          loading: false,
          items: payload.data,
          meta: payload.meta,
        },
      };
    case GET_PROFILE_GROUPS_ERROR:
      return {
        ...state,
        profileGroups: {
          ...state.profileGroups,
          loading: false,
          error: payload,
        },
      };
    default:
      return null;
  }
};
